import axios from 'axios';

// Domínio em variável de ambiente para a migração de marca poder trocar o
// endereço sem mexer em código. O padrão é o domínio atual, então nada muda
// enquanto `REACT_APP_API_URL` não for definida no build do Vercel.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.disparaia.net',
  timeout: 15000,
});

// Importar CSV não cabe nos 15s acima, e foi exatamente isso que o cliente viu em
// 21/10/2026: "deu erro e no log não aparece nada". O axios abortava a importação, o
// erro chegava SEM `response` (então a tela caía na mensagem genérica) e o servidor
// seguia inserindo sem logar nada. O backend passou a inserir em lote — 17.000
// contatos saem de ~270s para ~1s —, mas o teto ainda precisa caber no pior caso:
// arquivo grande, link ruim do cliente e um cold start do Railway no meio.
//
// Vale SÓ para o upload: manter os 15s no resto é o que faz uma rota pendurada
// aparecer como erro em vez de deixar a tela girando para sempre.
export const TIMEOUT_UPLOAD = 180000;

// Os 🩺 leem o sistema do TENANT ao vivo — o do Box faz 9 chamadas à API da
// barbearia, e o contrato dela diz que cada conversa com o Sheets leva de 1 a 3
// segundos. Com os 15s globais o navegador abortava e a tela mostrava "Falha ao
// rodar o diagnóstico" numa integração que estava funcionando: erro genérico
// porque, abortando do lado do cliente, não há `response` com a mensagem real.
// 90s cobre o pior caso do backend (4 passos de rede em série × 15s de timeout
// por chamada) com folga, e só vale para diagnóstico — o resto do painel segue
// com 15s, que é o que faz rota pendurada virar erro visível.
export const TIMEOUT_DIAGNOSTICO = 90000;

//const api = axios.create({
//  baseURL: 'http://localhost:3000'
//});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Não redireciona se já estamos na tela de login — evita boot loop
      // quando uma chamada secundária (ex: /tenant/meu-tenant) falha com 401
      // logo após login em iOS Safari (timing/clock skew/cookies bloqueados).
      const naLogin = window.location.pathname === '/login';
      // Também ignora a própria rota de login: erro 401 ali é credencial errada,
      // tratado pelo Login.jsx — não deve recarregar a página.
      const ehChamadaDeLogin = error.config?.url?.includes('/auth/login');
      if (!naLogin && !ehChamadaDeLogin) {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('ultima_atividade');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;